<mat-form-field appearance="fill" [style.width.em]="11">
    <input matInput #quantityInput [value]="fieldValue" (keypress)="onKeyPress($event)" [attr.maxlength]="maxlength"
        type="number"
        oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);">
    <button mat-mini-fab matPrefix (click)="add(-1)" [style.backgroundColor]="buttonBGColor"
        [style.color]="buttonFGColor">
        <mat-icon>remove</mat-icon>
    </button>
    <button mat-mini-fab matSuffix (click)="add(1)" [style.backgroundColor]="buttonBGColor"
        [style.color]="buttonFGColor">
        <mat-icon>add</mat-icon>
    </button>
</mat-form-field>